import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, API, buildError } from '../../api/apis';
import { ApiResponse, CreateSubscriptionRequest, CreateSubscriptionResponse, ListSubscriptionRequest, ListSubscriptionResponse, SubscriptionDetails } from '../../interfaces/interfaces';

export const subscriptionsService = createApi({
  reducerPath: 'subscriptionsApi',
  tagTypes: ['Subscriptions'],
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getSubscriptions: builder.query({
      query: ({ payload, headers }: { payload: ListSubscriptionRequest, headers?: HeadersInit }) => ({
        url: `${API.FETCH_SUBSCRIPTIONS(payload)}`,
        method: 'GET',
        headers: {
          ...headers,
        },
      }),
      providesTags: () =>  [{ type: 'Subscriptions', id: 'GET' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response?.Subscriptions as SubscriptionDetails[];
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    createSubscription: builder.mutation({
      query: ({ payload }: { payload: CreateSubscriptionRequest }) => ({
        url: `${API.CREATE_SUBSCRIPTION()}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: () => [{ type: 'Subscriptions', id: 'CREATE' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as CreateSubscriptionResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubscriptionsQuery, useLazyGetSubscriptionsQuery, useCreateSubscriptionMutation } = subscriptionsService;
